export default "__VITE_PUBLIC_ASSET__36a4d1e6__"